import type { BoatData, BoatTab } from "./types";

export type BoatDataCache = Record<string, BoatData>;

function cacheKey(boat: Pick<BoatData | BoatTab, "sheetId">): string {
  return String(boat.sheetId);
}

export function createBoatDataCache(boats: BoatData[] = []): BoatDataCache {
  const cache: BoatDataCache = {};

  for (const boat of boats) {
    cache[cacheKey(boat)] = boat;
  }

  return cache;
}

export async function getOrFetchBoatData(
  tab: BoatTab,
  cache: BoatDataCache,
  fetchBoat: (tab: BoatTab) => Promise<BoatData | null>
): Promise<BoatData | null> {
  const key = cacheKey(tab);
  const cached = cache[key];
  if (cached) return cached;

  const boat = await fetchBoat(tab);
  if (boat) cache[key] = boat;

  return boat;
}
